import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  helperText: {
    color: "red !important",
    margin: "0",
  },
  textField: {
    width: "100%",
    "&: focus": {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));
export default useStyles;
